<div class="col-12" *ngIf="pageload">
    <app-busy [message]="message"></app-busy>
</div>
<div class="col-12" *ngIf="myLoader">
    <app-busy [message]="message"></app-busy>
</div>

<div class="content" id="permitConfirm">
    <div class="container-fluid Confirmation-invoice">
        <div class="content" id="PDFcontent">
            <div class="confirmation-block" id="confirm-content" *ngIf="showBlock">
                <div class="col-md-12 p-0 ">
                    <div class="card border-light shadow-sm">
                        <div class="row mb-3 " #content id="pdfContent">
                            <div class="col-sm-5 p-0">
                                <div class="col-md-12">
                                    <table id="pdfTable1" style="margin-left: 20px;" width="800">
                                        <tbody>
                                        <th colspan="4">
                                            <h5 style="margin-left:-20px; font-size: 105%; font-weight:700;">

                                            </h5>
                                            <div class="routes-1 opensans-semi-bold-sapphire-30px">
                                                <span class="opensans-semi-bold-sapphire-30px">Application for Renewal of Permit</span>
                                                <div class="rectangle-210"></div>
                                                <br/>
                                            </div>
                                        </th>
                                        <tr>
                                            <th width="20%"><span class="head-text"><b>Account No :</b></span></th>
                                            <td width="80%"><span> {{debtorAccountId}}</span></td>
                                        </tr>
                                        <tr>
                                            <th><span class="head-text"><b>Application No :</b></span></th>
                                            <td><span>{{dataCntrl['application'].id}}</span></td>
                                        </tr>
                                        <tr>
                                            <th><span class="head-text"><b>Application Date:</b></span></th>
                                            <td>
                                                <span>{{dataCntrl['application'].date_created | date :'dd/MM/yyyy'}}</span>
                                            </td>
                                        </tr>
                                        <!-- <tr>
                                          <td><span class = "head-text">My Reference:</span></td>
                                          <td><span >{{dataCntrl['application'].reference_num}}</span></td>
                                        </tr> -->
                                        <tr>
                                            <th><span class="head-text"><b>Applicant :</b></span></th>
                                            <td><span>{{dataCntrl['application']['carrier'].name}}</span></td>
                                        </tr>
                                        <tr>
                                            <th><span class="head-text"><b>Email Address :</b></span></th>
                                            <td><span>{{dataCntrl['application']['carrier'].email}}</span></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style="margin-top:38px; margin-bottom:-60px; margin-left:200px; font-size: 93%"
                                 class="col-sm-5 p-0">
                                <div class="row mb-3 " #content id="pdfContent">
                                    <div class="col-md-12">
                                        <table id="pdfTable2">
                                            <tbody>
                                            <tr>
                                                <th>
                                                    <h6 style="margin-bottom:2px"><b>Physical Address</b></h6>
                                                </th>
                                            </tr>
                                            <tr>
                                                <th style="padding-left:20px;"><span class="head-text"><b>Address :</b></span>
                                                </th>
                                                <td> {{dataCntrl['application']['carrier'].physical_address_1}}</td>
                                            </tr>
                                            <tr>
                                                <th style="padding-left:20px;"><span
                                                        class="head-text"><b>Town :</b></span></th>
                                                <td>{{dataCntrl['application']['carrier'].physical_address_town}}</td>
                                            </tr>
                                            <tr>
                                                <th style="padding-left:20px;"><span class="head-text"><b>Post Code:</b></span>
                                                </th>
                                                <td>
                                                    <span>{{dataCntrl['application']['carrier'].physical_post_code}}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style="padding-left:20px;"><span
                                                        class="head-text"><b>Country:</b></span></th>
                                                <td>{{country}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <div class="row s-content">
                        <div class="col-md-12">
                            <app-app-motivation [hideEdit]="true" [dataCntrl]="dataCntrl"></app-app-motivation>
                        </div>
                    </div>
                    <br/>
                    <header>
                        <h1 class="opensans-semi-bold-sapphire-30px">Documents</h1>
                    </header>
                    <div class="row s-content">
                        <app-app-uploads isPermitDoc="true" [dataCntrl]="dataCntrl"
                                         [hideEdits]="true"></app-app-uploads>


                    </div>


                    <div class="card border-light shadow-sm" style="z-index: 900">
                        <br/>
                        <br/>
                        <div class="routes-1 opensans-semi-bold-sapphire-30px">
                            <span class="opensans-semi-bold-sapphire-30px">Route</span>
                            <div class="rectangle-210"></div>
                            <br/>
                        </div>
                        <app-ext-route-list [dataCntrl]="dataCntrl" [hideHeader]="false" [renewal]="true"
                                            [crId]="renewCrId" [permitId]="dataCntrl.permit.id"></app-ext-route-list>
                        <br/>
                        <br/>
                    </div>
                    <div class="card border-light shadow-sm">
                        <div class="pull-right" style="margin-bottom: 10px;">
                            <table id="pdfTable4">
                                <tbody>
                                <tr>
                                    <th><h3>Your Account Balance:</h3></th>
                                    <td [ngClass]="{'error-color':accountBalance < 0}">{{dataCntrl.application.carrier?.account_balance}}</td>
                                </tr>

                                </tbody>
                            </table>

                        </div>

                        <table class="table table-striped" id="pdfTable">
                            <thead>
                            <tr>
                                <th>Vehicle Registration</th>
                                <th>Vehice Type</th>
                                <th>Start Date</th>
                                <th>Permit Type</th>
                                <th>Duration</th>
                                <!-- <th >Permit Number</th> -->
                                <th>Application Fee</th>
                                <th>Permit Fee</th>
                                <th style="text-align:right">Line Total</th>
                            </tr>
                            </thead>
                            <tbody>
                            <ng-container *ngIf="vehicles.length>0">
                                <tr *ngFor="let list of vehicles">
                                    <td>{{list.registration_number}}</td>
                                    <td>{{list.vehicle_type}}</td>
                                    <td>{{list.start_date | date : 'dd/MM/yyyy'}}</td>
                                    <td>{{dataCntrl.application?.permit_type?.description}}</td>
                                    <td *ngIf="dataCntrl.application?.permit_type?.permit_years > 0">{{dataCntrl.application?.permit_type?.permit_years}}
                                        - Years
                                    </td>
                                    <td *ngIf="dataCntrl.application?.permit_type?.permit_months > 0">{{dataCntrl.application?.permit_type?.permit_months}}
                                        - Months
                                    </td>
                                    <td *ngIf="dataCntrl.application?.permit_type?.permit_days > 0">{{dataCntrl.application?.permit_type?.permit_days}}
                                        - Days
                                    </td>
                                    <!-- <td >{{dataCntrl.application?.permit[0].permit_num}} /
                                      {{dataCntrl.application?.permit[0].permit_issue}}

                                    </td> -->
                                    <td [ngClass]="{'error-color':chargeInd!=0}">{{dataCntrl.application?.permit_type?.current_application_fee}}</td>
                                    <td [ngClass]="{'error-color':chargeInd!=0}">{{dataCntrl.application?.permit_type?.current_fee}}</td>

                                    <td style="text-align:right">{{lineTotal}}</td>
                                </tr>
                            </ng-container>
                            <ng-container *ngIf="vehicles==null ||vehicles.length==0">
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{dataCntrl['application']['permit_type'].description}}</td>
                                    <td *ngIf="dataCntrl.application?.permit_type?.permit_years > 0">{{dataCntrl.application?.permit_type?.permit_years}}
                                        - Years
                                    </td>
                                    <td *ngIf="dataCntrl.application?.permit_type?.permit_months > 0">{{dataCntrl.application?.permit_type?.permit_months}}
                                        - Months
                                    </td>
                                    <td *ngIf="dataCntrl.application?.permit_type?.permit_days > 0">{{dataCntrl.application?.permit_type?.permit_days}}
                                        - Days
                                    </td>
                                    <td></td>
                                    <td>{{dataCntrl.application?.permit_type?.current_application_fee}}</td>
                                    <td></td>
                                    <td>{{dataCntrl.application?.permit_type?.current_fee}}</td>
                                </tr>
                            </ng-container>
                            <tr>
                                <td colspan="7" style="text-align:right;">Total</td>

                                <td style="text-align:right;"> {{totalFee }}</td>
                            </tr>
                            <tr>
                                <td colspan="6" rowspan="3" align="center" [ngClass]="{'error-color':chargeInd!=0}">
                                    Fees shown in red are due on submission of the application. The remaining fee(s) if
                                    any will be payable before any permit is issued. These fees could change later
                                </td>
                                <td style="text-align:right;width:200px;" [ngClass]="{'error-color':chargeInd!=0}">
                                    Payable on submission
                                </td>

                                <td style="text-align:right;"
                                    [ngClass]="{'error-color':chargeInd!=0}"> {{submissionAmt }}</td>
                            </tr>
                            <tr>
                                <td style="text-align:right;">Amount paid</td>

                                <td style="text-align:right;"> {{paidAmt }}</td>
                            </tr>
                            <tr>
                                <td style="text-align:right;" class="error-color">Amount Due now</td>

                                <td style="text-align:right;" class="error-color"> {{dueAmt }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <table>
                            <tbody>
                            <tr>
                                <td colspan="2" style="border:0px;border-bottom:1px solid #ccc;text-align:center;"
                                    [innerHTML]="linkhtml?.Value"></td>
                            </tr>
                            <tr>
                                <td style="color:#1D3F94;border:0px;border-bottom:1px solid #ccc;border-right:1px solid #ccc;">
                                    Declaration by {{userDetails.FirstName}} {{userDetails.LastName}} on
                                    <strong>{{decl_date|date : 'dd/MM/yyyy'}}</strong></td>
                                <td style="color:#1D3F94;border:0px;border-bottom:1px solid #ccc;">
                    <span>You declare that you agree with the declaration above by checking the box:
                    </span>
                                    <input type="checkbox"
                                           style="position:relative;top:2px;transform: scale(1.5);margin-left:8px;"
                                           ([ngModel])="termsFlag" (click)="checkTerms($event)" name="terms"/>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" style="border:0px;text-align:right;padding-top:20px;">
                                    <button title="Cancel" (click)="cancelApplication()" name="download" type="submit"
                                            id="" class="btn btn-md m-clr pull-right hd-btn"
                                            style=" margin-right:10px;margin-bottom:5px; ">Close
                                    </button>
                                    <button title="Submit Application "
                                            name="SubmitApplication" (click)="SubmitApplication()"
                                            [disabled]="!this.termsFlag && (dueAmt > dataCntrl.application.carrier?.account_balance)" type="submit" id=""
                                            class="btn btn-md m-clr pull-right hd-btn"
                                            style=" margin-right:10px;margin-bottom:5px;">Submit and Pay Account Balance
                                    </button>

                                    <button title="Submit Application" name="SubmitApplication" (click)="PayGate()"
                                            [disabled]="!this.termsFlag" type="submit" style=" margin-right:10px;margin-bottom:5px; "  type="button" class="btn btn-md m-clr hd-btn">Submit and Pay with Bank Card
                                    </button>

                                </td>

                            </tr>

                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>
        <!--<div class="col-md-12 p-0" id="ignoreContent">
          <button title="Download PDF" name="download" type="submit" id="btnSave" (click)="downloadPdf()"  class="btn btn-md m-clr pull-right hd-btn" style="width:auto; margin-right:0px;margin-bottom:5px;  ">Download PDF</button>
      </div>-->
    </div>
</div>
